"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModeratorTagsProvider = exports.ModeratorTagsContext = void 0;
exports.withModeratorTagsContext = withModeratorTagsContext;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModeratorTagsContext = (0, _preactCompat.createContext)({
  moderatorTags: []
});
exports.ModeratorTagsContext = ModeratorTagsContext;

var ModeratorTagsProvider = function ModeratorTagsProvider(context) {
  return (0, _preact.h)(ModeratorTagsContext.Provider, {
    value: {
      moderatorTags: context.moderatorTags
    }
  }, context.children);
};

exports.ModeratorTagsProvider = ModeratorTagsProvider;

function withModeratorTagsContext(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(WithModeratorTagsContextWrapper, _Component);

    var _super = _createSuper(WithModeratorTagsContextWrapper);

    function WithModeratorTagsContextWrapper() {
      (0, _classCallCheck2.default)(this, WithModeratorTagsContextWrapper);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(WithModeratorTagsContextWrapper, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return (0, _preact.h)(ModeratorTagsContext.Consumer, null, function (context) {
          return (0, _preact.h)(WrappedComponent, (0, _extends2.default)({}, props, {
            moderatorTags: context.moderatorTags
          }));
        });
      }
    }]);
    return WithModeratorTagsContextWrapper;
  }(_preact.Component);
}